export default function Footer() {
  return (
    <footer className="border-t border-neutral-200/80 bg-stone-50/70 py-8 transition-colors dark:border-neutral-800 dark:bg-neutral-950/70 sm:py-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <p className="mx-auto max-w-3xl text-center text-xs leading-6 text-neutral-500 dark:text-neutral-500 sm:text-sm">
          <span className="font-semibold text-neutral-700 dark:text-neutral-300">Disclaimer:</span>{" "}
          The views and opinions expressed on this site are my own and do not
          represent the views of any organization I am or was affiliated with.
        </p>
      </div>
    </footer>
  );
}
